const queries = [
	{ name: 'Dashboard', path: '/' },
	{ name: 'Sorting', path: 'sorting' },
	{ name: 'Searching', path: 'searching' },
	{ name: 'Data Structures', path: 'datastructures' },
	{ name: 'Graphs', path: 'graphs' },
	{ name: 'Trees', path: 'trees' },
	{ name: 'Backtracking', path: 'backtracking' },
	{ name: 'Bubble Sort', path: 'bubblesort' },
	{ name: 'Selection Sort', path: 'selectionsort' },
	{ name: 'Insertion Sort', path: 'insertionsort' },
	{ name: 'Quick Sort', path: 'quicksort' },
	{ name: 'Merge Sort', path: 'mergesort' },
	{ name: 'Heap Sort', path: 'heapsort' },
	{ name: 'Linear Search', path: 'linearsearch' },
	{ name: 'Binary Search', path: 'binarysearch' },
	{ name: 'Singly Linked List', path: 'singlylinkedlist' },
	{ name: 'Hash Table', path: 'hashtable' },
	{ name: 'Hash Table Quadratic Probing', path: 'hashtablequadratic' },
	{ name: 'Hash Table Linked List', path: 'hashtablelinkedlist' },
	{ name: "Dijkstra's", path: 'dijkstras' },
	{ name: 'Bellman Ford', path: 'bellmanford' },
	{ name: 'Breadth First Search', path: 'breadthfirstsearch' },
	{ name: 'Depth First Search', path: 'depthfirstsearch' },
	{ name: "Prim's", path: 'prims' },
	{ name: "Kruskal's", path: 'kruskals' },
	{ name: 'AVL', path: 'avl' },
	{ name: 'Binary Search Tree', path: 'binarysearchtree' },
	{ name: 'Preorder', path: 'preorder' },
	{ name: 'Inorder', path: 'inorder' },
	{ name: 'Postorder', path: 'postorder' },
	{ name: 'Heaps', path: 'heaps' },
	{ name: 'Huffman Coding Tree', path: 'huffmancodingtree' },
	{ name: 'nQueens', path: 'nqueens' },
	{ name: 'Fibonacci Sequence', path: 'fibonaccisequence' },
	{ name: 'Towers of Hanoi', path: 'towersofhanoi' },
	{ name: 'Floodfill', path: 'floodfill' },
];

export default queries;
